import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { NS } from '@/screens/Service/ducks/reducer';
import {
  getDraftApiDocs,
  deleteDraftApiDoc,
  updateCrumbs
} from '@/screens/Service/ducks/actions';

import { DraftPages } from '../../components/DraftPages';

export const DraftApiDocs = props => {
  const { updateCrumbs } = props;
  useEffect(() => {
    updateCrumbs([
      {
        label: 'Drafts Api Docs'
      }
    ]);
  }, []);
  return <DraftPages nameField="version" {...props} />;
};

const mapStateToProps = state => ({
  service: state.getIn([NS, 'service']),
  drafts: state.getIn([NS, 'draftApiDocs']),
  pending: state.getIn([NS, 'pending', 'draftApiDocs'])
});
const mapDispatchToProps = dispatch => ({
  getDrafts: handle => dispatch(getDraftApiDocs(handle)),
  deleteDraft: id => dispatch(deleteDraftApiDoc(id)),
  updateCrumbs: crumbs => dispatch(updateCrumbs(crumbs))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DraftApiDocs);
